<div
  class="card accounting-widget"
  [ngClass]="isLoading ? 'skeleton-loader' : 'loaded'">
  <div class="card-body d-flex flex-column">
    <div class="card-title">
      <div class="row mb-3 align-items-center">
        <div class="col-auto">
          <div
            class="icon-rounded small-icon bg-secondary text-white"
            [ngClass]="{ 'loading': isLoading }">
            <i class="{{ hasAccounting() ? 'iconoir-refresh-circle' : 'iconoir-link' }}"></i>
          </div>
        </div>
        <div class="col">
          <div
            id="cardTitle"
            class="text-secondary"
            [ngClass]="{ 'loading': isLoading }">
            {{ hasAccounting() ? 'Sync transactions' : 'Link to your accounting software' }}
          </div>
        </div>
      </div>
    </div>
    <div class="card-text mb-4">
      <div [ngClass]="{ 'mb-3': !hasAccounting() }">
        @if (!hasAccounting()) {
          <div class="row my-auto align-items-center flex-nowrap gx-2 gx-md-3 accounting-not-linked">
            <div class="col-auto">
              <div
                class="accounting-logo"
                [ngClass]="{ 'loading': isLoading }">
                <img
                  ngSrc="./assets/dashboard/accounting-logos/pays-logo.svg"
                  alt="Paystashio"
                  width="16"
                  height="24" />
              </div>
            </div>
            <div class="col-auto">
              <i class="iconoir-arrow-right lead"></i>
            </div>
            @for (provider of providers(); track provider.name) {
              <ng-container
                [ngTemplateOutlet]="providerTemplate"
                [ngTemplateOutletContext]="{ $implicit: provider }"></ng-container>
            }
          </div>
        }

        <ng-template
          #providerTemplate
          let-provider>
          <div class="col-auto">
            <div
              class="accounting-logo"
              [ngClass]="{ 'loading': isLoading }">
              @if (provider.name === AccountingProviderCompany.QUICKBOOKS) {
                <img
                  ngSrc="./assets/dashboard/accounting-logos/quick-books-logo.svg"
                  alt="Quick Books"
                  width="26"
                  height="26" />
              }
              @if (provider.name === AccountingProviderCompany.XERO) {
                <img
                  ngSrc="./assets/dashboard/accounting-logos/xero-logo.svg"
                  alt="Xero"
                  width="26"
                  height="26" />
              }
              @if (provider.name === AccountingProviderCompany.SAGE) {
                <img
                  ngSrc="./assets/dashboard/accounting-logos/sage-logo.svg"
                  alt="Sage"
                  width="28"
                  height="12" />
              }
              @if (provider.name === AccountingProviderCompany.ZOHO) {
                <img
                  ngSrc="./assets/dashboard/accounting-logos/zoho-books-logo.svg"
                  alt="Zoho Books"
                  width="22"
                  height="21" />
              }
            </div>
          </div>
        </ng-template>
      </div>

      @if (hasAccounting()) {
        <div>
          <div
            class="count text-secondary"
            id="unsyncedTransactions">
            {{ unsyncedTransactions() }}
          </div>
          <div class="h6 text-muted mb-5 pb-3 pb-md-0">Transactions have not been synced</div>
          <img
            priority
            class="sync-widget-bg"
            ngSrc="./assets/dashboard/sync-widget/sync-bg.svg"
            width="354"
            height="107"
            alt="" />
        </div>
      }
    </div>
    <div class="text-end mt-auto position-relative">
      @if (hasAccounting()) {
        <button
          class="btn btn-primary btn-sm"
          (click)="navigateToTransactions()">
          View
        </button>
      } @else {
        @if (!hasAccounting()) {
          <a
            routerLink="/accounting/integrations"
            class="btn btn-primary btn-sm"
            [ngClass]="{ 'loading': isLoading }">
            Link now
          </a>
        }
      }
    </div>
  </div>
</div>
